"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[3364],{

/***/ 86512:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CK: () => (/* binding */ monoFontFamily),
/* harmony export */   NK: () => (/* binding */ EditLayout),
/* harmony export */   Nj: () => (/* binding */ EditLightProductionTheme),
/* harmony export */   PW: () => (/* binding */ EditLightTheme),
/* harmony export */   Rv: () => (/* binding */ EditDarkProductionTheme),
/* harmony export */   f8: () => (/* binding */ editOverrides),
/* harmony export */   rH: () => (/* binding */ proseFamily),
/* harmony export */   wM: () => (/* binding */ EditDarkTheme)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70531);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92539);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38591);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2780);




const monoFontFamily = `Inconsolata, Monaco, monospace`;
const proseFamily = `Inter, -apple-system, BlinkMacSystemFont, sans-serif`;
const editOverrides = {
    name: "edit",
    borders: {
        radius300: "6px",
        radius400: "10px",
        checkboxBorderRadius: "4px"
    },
    grid: {
        columns: [
            4,
            8,
            12
        ],
        gutters: [
            16,
            16,
            16
        ],
        margins: [
            0,
            12,
            24
        ]
    },
    lighting: {
        ..._primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetShadows */ .Ro,
        shadow400: "0px 1px 0px rgba(0, 0, 0, 0.07);",
        shadow700: "-2px 2px 0px rgba(0, 0, 0, 0.07);"
    },
    typography: {
        ..._primitives__WEBPACK_IMPORTED_MODULE_1__/* .productTypography */ .uQ,
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateTypography */ .l8)({
            primaryFontFamily: monoFontFamily,
            monoFontFamily: monoFontFamily,
            typography: {
                ParagraphXSmall: {
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "16px"
                },
                ParagraphMedium: {
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "20px"
                },
                LabelSmall: {
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "20px"
                },
                LabelMedium: {
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "20px"
                },
                LabelLarge: {
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: "24px"
                },
                // HeadingXSmall is used for ModalHeader, hence is 'larger' than other scaled Heading overrides
                HeadingXSmall: {
                    fontSize: "20px",
                    fontWeight: 500,
                    lineHeight: "28px"
                },
                HeadingSmall: {
                    fontSize: "16px",
                    fontWeight: "normal",
                    lineHeight: "20px"
                },
                HeadingMedium: {
                    fontSize: "17px",
                    fontWeight: "normal",
                    lineHeight: "28px"
                },
                HeadingLarge: {
                    fontSize: "16px",
                    fontWeight: 600,
                    lineHeight: "40px"
                },
                HeadingXLarge: {
                    fontSize: "16px",
                    fontWeight: 700,
                    lineHeight: "20px"
                },
                HeadingXXLarge: {
                    fontSize: "20px",
                    fontWeight: 600,
                    lineHeight: "30px"
                }
            }
        })
    }
};
var SemanticType;
(function(SemanticType) {
    SemanticType[SemanticType["Development"] = 0] = "Development";
    SemanticType[SemanticType["Production"] = 1] = "Production";
})(SemanticType || (SemanticType = {}));
const getSemanticOverrides = (type, colors)=>{
    const developmentOverrides = {
        colors: {
            ...colors,
            contentSecondary: colors.primary500,
            contentSecondaryOriginal: colors.primary600,
            contentAccent: colors.electricBlue500,
            contentInfo: colors.blue700,
            contentNegative: colors.red700,
            contentWarning: colors.yellow700,
            contentPositive: colors.green700,
            contentDevelopment: colors.development,
            contentProduction: colors.purple500,
            contentDisabledDevelopment: colors.disabledDevelopment,
            backgroundQuaternary: colors.primary200,
            backgroundQuinary: colors.primary300,
            backgroundInverseTertiary: colors.primary700,
            backgroundInfo: colors.blue50,
            backgroundNegative: colors.red50,
            backgroundWarning: colors.yellow50,
            backgroundPositive: colors.green50,
            backgroundSubtleBlue: colors.electricBlue50,
            backgroundProduction: colors.purple50,
            borderFocus: colors.electricBlue500,
            borderSelected: colors.electricBlue400,
            borderAlt: colors.primary200,
            borderInfo: colors.blue400,
            borderNegative: colors.red500,
            borderError: colors.red500,
            borderWarning: colors.yellow600,
            borderPositive: colors.green200,
            buttonPrimaryFill: colors.primary700,
            buttonPrimaryHover: colors.primary600,
            buttonSecondaryFill: colors.neutralMin,
            buttonSecondaryHover: colors.primary50,
            buttonTertiaryHover: colors.alpha0,
            inputFill: "rgba(0, 0, 0, 0.01)",
            inputFillActive: colors.neutralMin,
            inputBorder: colors.primary300,
            inputBorderError: colors.red500,
            environmentInputFill: "#FBF7F0",
            linkText: colors.primary700,
            linkVisited: colors.primary700,
            linkHover: colors.primary600,
            contentLinkText: colors.electricBlue500,
            contentLinkHover: colors.electricBlue600,
            contentLinkActive: colors.electricBlue700,
            menuFontDefault: colors.neutralMax,
            tickBorderError: colors.red500,
            tickFillErrorSelected: colors.red500,
            tickFillErrorSelectedHover: colors.red600,
            tickFillErrorSelectedHoverActive: colors.red700
        },
        borders: {
            buttonBorderRadius: "6px",
            inputBorderRadius: "6px",
            popoverBorderRadius: "6px",
            surfaceBorderRadius: "6px",
            tableBorderRadius: "8px"
        }
    };
    if (type == 1) {
        const productionOverrides = {
            colors: {
                contentSecondaryOriginal: colors.purple600,
                contentInfo: colors.purple600,
                backgroundTertiary: colors.purple50,
                backgroundQuaternary: colors.purple200,
                backgroundQuinary: colors.purple300,
                backgroundInverseTertiary: colors.purple700,
                backgroundInfo: colors.purple50,
                borderFocus: colors.purple500,
                borderSelected: colors.purple400,
                borderOpaque: colors.purple200,
                borderAlt: colors.purple200,
                borderInfo: colors.purple200,
                buttonPrimaryFill: colors.purple700,
                buttonPrimaryHover: colors.purple600,
                buttonSecondaryFill: colors.purple50,
                buttonSecondaryHover: colors.purple200,
                buttonTertiaryHover: colors.purple50,
                buttonDisabledFill: colors.purple50,
                buttonMinimalHover: colors.purple50,
                inputFill: colors.purple50,
                inputBorder: colors.purple200,
                inputPlaceholder: colors.purple300,
                environmentInputFill: colors.purple50,
                tableStripedBackground: colors.purple50
            },
            borders: {
                // NOTE: These colours are opaque, while the default border colours are transparent
                border100: {
                    borderColor: colors.purple50
                },
                border200: {
                    borderColor: colors.purple100
                },
                border300: {
                    borderColor: colors.purple200
                },
                border400: {
                    borderColor: colors.purple300
                },
                border500: {
                    borderColor: colors.purple400
                },
                border600: {
                    borderColor: colors.purple500
                }
            }
        };
        return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, developmentOverrides, productionOverrides);
    } else {
        return developmentOverrides;
    }
};
// PRIMITIVE OVERRIDES ////////////////////////////////////////////////////////
const primitivesLight = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .zG)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_)
};
const primitivesDark = {
    ...(0,_primitives__WEBPACK_IMPORTED_MODULE_1__/* .getPrimitiveColors */ .zG)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql)
};
// COLOR PALETTE OVERRIDES ////////////////////////////////////////////////////
const EditLightTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_), editOverrides));
const EditLightProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(primitivesLight, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsLight */ .d_), editOverrides));
const EditDarkTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(0, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql), editOverrides));
const EditDarkProductionTheme = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(primitivesDark, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, getSemanticOverrides(1, _primitives__WEBPACK_IMPORTED_MODULE_1__/* .gadgetColorsDark */ .Ql), editOverrides));
// for debugging, its nice to be able to just see the theme values easily
if (false) {}
const EditLayout = {
    smallSubNavigationWidth: "368px",
    mediumSubNavigationWidth: "392px",
    minimumEditPaneWidth: "432px",
    maximumEditPaneWidth: "816px",
    connectionsIndexWidth: "900px",
    connectionsModalWidth: "900px",
    appSettingIndexWidth: "900px",
    resizablePaneStartWidth: 526
};


/***/ }),

/***/ 7363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ Row)
/* harmony export */ });
/* unused harmony export Spacer */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Row = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "row",
        justifyContent: props.$align,
        alignItems: "center",
        gap: props.$gap
    }));
const Spacer = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    flexGrow: 1
});


/***/ }),

/***/ 92146:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   zx: () => (/* binding */ Button)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2780);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67710);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19895);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);
/* harmony import */ var _utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62719);


// eslint-disable-next-line no-restricted-imports





// eslint-disable-next-line no-restricted-imports

/**
 * BaseUI reexport for minimal buttons because we need to pass overrides to style the text right. Wherever you want to use a <Button />, you should use this instead.
 * See https://github.com/uber/baseweb/issues/106 for more information
 */ const Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)();
    const rawProps = {};
    const kind = props.kind ?? "primary";
    const rawSize = props.size == "tight" ? baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact : props.size == "square" ? baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.default : props.size;
    const overrides = {
        BaseButton: {
            style: {
                cursor: props.disabled ? "not-allowed !important" : "pointer",
                transitionProperty: "background, background-color",
                transitionDuration: "0s",
                ":focus-visible": {
                    outline: `2px solid ${$theme.colors.borderFocus}`,
                    outlineOffset: "1px"
                },
                userSelect: "none"
            }
        }
    };
    switch(props.size){
        case "tight":
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .paddingUtil */ .N1)($theme.sizing.scale0)
                    }
                });
                break;
            }
        case baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.large:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .paddingVertical */ .i6)($theme.sizing.scale500)
                    }
                });
                break;
            }
        case undefined:
        case baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact:
        case baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.default:
            {
                lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
                    BaseButton: {
                        style: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .paddingUtil */ .N1)($theme.sizing.scale200, $theme.sizing.scale500)
                    },
                    StartEnhancer: {
                        style: {
                            marginRight: $theme.sizing.scale400
                        }
                    }
                });
            }
    }
    if (kind == "primary") {
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
            BaseButton: {
                style: {
                    backgroundColor: $theme.colors.primary700,
                    boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .borderShadow */ .ic)($theme.colors.neutralMax, 1, $theme.lighting.shadowButtonPrimary),
                    borderWidth: 0,
                    ":active:not(:disabled)": {
                        boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .borderShadow */ .ic)($theme.colors.neutralMax, 0, $theme.lighting.shadowButtonPrimaryInset)
                    },
                    ":active:not(:disabled) > *": {
                        transform: "translateY(1px)"
                    },
                    ":disabled": {
                        backgroundColor: $theme.colors.alpha300,
                        color: $theme.colors.primary50,
                        boxShadow: "none"
                    }
                }
            }
        });
    } else if (kind == "secondary") {
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
            BaseButton: {
                style: {
                    boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .borderShadow */ .ic)($theme.colors.primary300, 1, $theme.lighting.shadowButton),
                    borderWidth: 0,
                    backgroundColor: $theme.colors.neutralMin,
                    ":active:not(:disabled)": {
                        boxShadow: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .borderShadow */ .ic)($theme.colors.primary300, 1, $theme.lighting.shadowButtonInset),
                        backgroundColor: $theme.colors.primary50
                    },
                    ":active:not(:disabled) > *": {
                        transform: "translateY(1px)"
                    },
                    ":disabled": {
                        backgroundColor: $theme.colors.primary50,
                        boxShadow: "none"
                    }
                }
            }
        });
    } else if (kind === baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .KIND */ .TO.minimal || kind === baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .KIND */ .TO.tertiary) {
        const activeStyle = {
            backgroundColor: "transparent",
            boxShadow: "none",
            textDecoration: "underline"
        };
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, {
            BaseButton: {
                style: {
                    ...(0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .paddingUtil */ .N1)("1px", $theme.sizing.scale100),
                    color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact ? $theme.colors.linkText : $theme.colors.contentLinkText,
                    textDecoration: $theme.typography.contentLink.textDecoration,
                    backgroundColor: "transparent",
                    textUnderlineOffset: "3px",
                    borderWidth: 0,
                    ":hover:not(:disabled)": {
                        ...activeStyle
                    },
                    ":hover:not(:disabled):not(:active)": {
                        ...activeStyle,
                        color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover
                    },
                    ":focus-visible": {
                        ...activeStyle,
                        color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact ? $theme.colors.linkHover : $theme.colors.contentLinkHover,
                        outlineOffset: "3px"
                    },
                    ":disabled": {
                        color: $theme.colors.alpha400,
                        backgroundColor: "transparent"
                    },
                    ":active:not(:disabled)": {
                        ...activeStyle,
                        color: props.size == baseui_button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact ? $theme.colors.linkActive : $theme.colors.contentLinkActive
                    }
                }
            }
        });
    }
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides, props.overrides);
    // normalizeKeys is not a valid prop for Button
    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(rawProps, lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
        "children",
        "normalizeKeys"
    ]));
    if (props.$style) {
        lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(overrides.BaseButton.style, props.$style);
    }
    // wrap any child that is a raw string in a wrapper span, so that the CSS selectors which translate the children on active can target them. children that are already an element and not a string aren't wrapped to keep things as unchanged as possible
    // eslint-disable-next-line react/jsx-key
    const children = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(props.children, (child)=>{
        return typeof child === "string" ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
            style: {
                whiteSpace: "pre-wrap"
            }
        }, child) : child;
    });
    const button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(baseui_button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        ref: ref,
        ...rawProps,
        overrides: overrides,
        kind: kind,
        size: rawSize
    }, children);
    return props.normalizeKeys ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_utils_KeyNormalizedControl__WEBPACK_IMPORTED_MODULE_7__/* .KeyNormalizedControl */ .w, {
        mode: "simple",
        ignoreKeyProps: {
            style: {
                lineHeight: "0"
            }
        }
    }, button) : button;
});


/***/ }),

/***/ 38591:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ql: () => (/* binding */ gadgetColorsDark),
/* harmony export */   Ro: () => (/* binding */ gadgetShadows),
/* harmony export */   d_: () => (/* binding */ gadgetColorsLight),
/* harmony export */   uQ: () => (/* binding */ productTypography),
/* harmony export */   zG: () => (/* binding */ getPrimitiveColors)
/* harmony export */ });
/* unused harmony exports space, radii */
const gadgetColorsLight = {
    neutralMin: "#FFF",
    neutralMax: "#000",
    primary50: "#F6F6F6",
    primary100: "#EEEEEE",
    primary200: "#E2E2E2",
    primary300: "#CBCBCB",
    primary400: "#AFAFAF",
    primary500: "#757575",
    primary600: "#545454",
    primary700: "#333333",
    alpha0: "rgba(0, 0, 0, 0)",
    alpha50: "rgba(0, 0, 0, 0.03)",
    alpha100: "rgba(0, 0, 0, 0.07)",
    alpha200: "rgba(0, 0, 0, 0.11)",
    alpha300: "rgba(0, 0, 0, 0.2)",
    alpha400: "rgba(0, 0, 0, 0.31)",
    alpha500: "rgba(0, 0, 0, 0.54)",
    alpha600: "rgba(0, 0, 0, 0.67)",
    alpha700: "rgba(0, 0, 0, 0.8)",
    alpha800: "rgba(0, 0, 0, 0.9)",
    alpha900: "rgba(0, 0, 0, 0.95)",
    electricBlue50: "#ECECFF",
    electricBlue100: "#D9D9FE",
    electricBlue200: "#B3B3FE",
    electricBlue300: "#8E8EFD",
    electricBlue400: "#6868FD",
    electricBlue500: "#4242FC",
    electricBlue600: "#3535CE",
    electricBlue700: "#2828A0",
    yellow50: "#FEF3EF",
    yellow100: "#FBE2D6",
    yellow200: "#F7BFA5",
    yellow300: "#F19164",
    yellow400: "#ED6E33",
    yellow500: "#B45427",
    yellow600: "#8E431F",
    yellow700: "#5F2C14",
    red50: "#FBECEB",
    red100: "#F6D9D6",
    red200: "#EEB4AD",
    red300: "#E58E85",
    red400: "#D44333",
    red500: "#AE372A",
    red600: "#892C21",
    red700: "#5C1D16",
    green50: "#F0F9F4",
    green100: "#DAF0E3",
    green200: "#AEDDC2",
    green300: "#73C496",
    green400: "#3AA76D",
    green500: "#368759",
    green600: "#2B6B46",
    green700: "#1C472F",
    blue50: "#EFF8FF",
    blue100: "#D2EFFF",
    blue200: "#B6E5FF",
    blue300: "#92D7FE",
    blue400: "#63C7FF",
    blue500: "#3A9BD1",
    blue600: "#3383AF",
    blue700: "#1B5B80",
    purple50: "#F5F2FC",
    purple100: "#E3D7FD",
    purple200: "#BFA8F2",
    purple300: "#9168EC",
    purple400: "#7340E4",
    purple500: "#5D39BB",
    purple600: "#361D77",
    purple700: "#261650",
    gellyPurple: "#9B50D7",
    development: "#87550B",
    disabledDevelopment: "#846C4AB2",
    backgroundDevelopment: "#FBF6EF"
};
const gadgetColorsDark = {
    neutralMin: "#000",
    neutralMax: "#FFF",
    primary50: "#333333",
    primary100: "#545454",
    primary200: "#757575",
    primary300: "#AFAFAF",
    primary400: "#CBCBCB",
    primary500: "#E2E2E2",
    primary600: "#EEEEEE",
    primary700: "#F6F6F6",
    alpha0: "rgba(255, 255, 255, 0)",
    alpha50: "rgba(255, 255, 255, 0.03)",
    alpha100: "rgba(255, 255, 255, 0.07)",
    alpha200: "rgba(255, 255, 255, 0.11)",
    alpha300: "rgba(255, 255, 255, 0.2)",
    alpha400: "rgba(255, 255, 255, 0.31)",
    alpha500: "rgba(255, 255, 255, 0.54)",
    alpha600: "rgba(255, 255, 255, 0.67)",
    alpha700: "rgba(255, 255, 255, 0.8)",
    alpha800: "rgba(255, 255, 255, 0.9)",
    alpha900: "rgba(255, 255, 255, 0.95)",
    electricBlue50: "#2828A0",
    electricBlue100: "#3535CE",
    electricBlue200: "#4242FC",
    electricBlue300: "#6868FD",
    electricBlue400: "#8E8EFD",
    electricBlue500: "#B3B3FE",
    electricBlue600: "#D9D9FE",
    electricBlue700: "#ECECFF",
    yellow50: "#5e4f13",
    yellow100: "#7b6718",
    yellow200: "#9D831F",
    yellow300: "#CEAC29",
    yellow400: "#FFD533",
    yellow500: "#FFDD5C",
    yellow600: "#FFE685",
    yellow700: "#FFEEAD",
    red50: "#5C1D16",
    red100: "#892C21",
    red200: "#AE372A",
    red300: "#D44333",
    red400: "#E58E85",
    red500: "#EEB4AD",
    red600: "#F6D9D6",
    red700: "#FBECEB",
    green50: "#1C472F",
    green100: "#2B6B46",
    green200: "#368759",
    green300: "#3AA76D",
    green400: "#73C496",
    green500: "#AEDDC2",
    green600: "#DAF0E3",
    green700: "#F0F9F4",
    blue50: "#2C79A5",
    blue100: "#3A9BD1",
    blue200: "#49BDFE",
    blue300: "#6DCAFE",
    blue400: "#92D7FE",
    blue500: "#B6E5FF",
    blue600: "#D2EFFF",
    blue700: "#EFF8FF",
    purple50: "#261650",
    purple100: "#361D77",
    purple200: "#5D39BB",
    purple300: "#7340E4",
    purple400: "#9168EC",
    purple500: "#BFA8F2",
    purple600: "#E3D7FD",
    purple700: "#F5F2FC",
    gellyPurple: "#8d3ccf",
    development: "#87550B",
    disabledDevelopment: "#846C4AB2",
    backgroundDevelopment: "#FBF6EF"
};
const gadgetShadows = {
    selected: "0px 2px 0px 1px rgb(66, 66, 252, 0.3)",
    depth2: "0px 3px 2px -1px rgba(0, 0, 0, 0.12)",
    depth3: "0px 8px 16px -4px rgba(0, 0, 0, 0.24)",
    depth4: "0px 12px 20px -8px rgba(0, 0, 0, 0.32)",
    shadowButton: "0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonPrimary: "0px -2px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)",
    shadowButtonInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.16) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.08) inset",
    shadowButtonPrimaryInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.32) inset, 1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset, -1px 0px 1px 0px rgba(0, 0, 0, 0.16) inset",
    shadowInputInset: "0px 2px 2px 0px rgba(0, 0, 0, 0.08) inset"
};
const productTypography = {
    title: {
        fontFamily: "Inconsolata",
        fontSize: "20px",
        fontWeight: "600",
        lineHeight: "30px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    navTitle: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "1px",
        textAlign: "left"
    },
    heading: {
        fontFamily: "Inconsolata",
        fontSize: "16px",
        fontWeight: "700",
        lineHeight: "22px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    subHeading: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: "700",
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    body: {
        fontFamily: "Inconsolata",
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    caption: {
        fontFamily: "Inconsolata",
        fontSize: "12px",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "0px",
        textAlign: "left"
    },
    contentLink: {
        textDecoration: "none"
    }
};
const getPrimitiveColors = (palette)=>({
        accent: palette.electricBlue500,
        accent50: palette.purple50,
        accent100: palette.purple100,
        accent200: palette.purple200,
        accent300: palette.purple300,
        accent400: palette.purple400,
        accent500: palette.purple500,
        accent600: palette.purple600,
        accent700: palette.purple700,
        negative50: palette.red50,
        negative100: palette.red100,
        negative200: palette.red200,
        negative300: palette.red300,
        negative400: palette.red400,
        negative500: palette.red500,
        negative600: palette.red600,
        negative700: palette.red700,
        warning50: palette.yellow50,
        warning100: palette.yellow100,
        warning200: palette.yellow200,
        warning300: palette.yellow300,
        warning400: palette.yellow400,
        warning500: palette.yellow500,
        warning600: palette.yellow600,
        warning700: palette.yellow700,
        positive50: palette.green50,
        positive100: palette.green100,
        positive200: palette.green200,
        positive300: palette.green300,
        positive400: palette.green400,
        positive500: palette.green500,
        positive600: palette.green600,
        positive700: palette.green700,
        primary50: palette.primary50,
        primary100: palette.primary100,
        primary200: palette.primary200,
        primary300: palette.primary300,
        primary400: palette.primary400,
        primary500: palette.primary500,
        primary600: palette.primary600,
        primary700: palette.primary700
    });
const space = {
    scale0: "2px",
    scale100: "4px",
    scale200: "6px",
    scale300: "8px",
    scale400: "10px",
    scale500: "12px",
    scale550: "14px",
    scale600: "16px",
    scale650: "18px",
    scale700: "20px",
    scale750: "22px",
    scale800: "24px",
    scale850: "28px",
    scale900: "32px",
    scale950: "36px",
    scale1000: "40px",
    scale1200: "48px",
    scale1400: "56px",
    scale1600: "64px",
    scale2400: "96px",
    scale3200: "128px",
    scale4800: "192px"
};
const radii = {
    radius100: "2px",
    radius200: "4px",
    radius300: "8px",
    radius400: "12px"
};


/***/ }),

/***/ 62719:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w: () => (/* binding */ KeyNormalizedControl)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(22764);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-hotkeys-ce@2.0.6_react@0.0.0-experimental-4ead6b530/node_modules/react-hotkeys-ce/index.es.js
var index_es = __webpack_require__(26722);
// EXTERNAL MODULE: ../@gadgetinc/errors/index.ts
var errors = __webpack_require__(38353);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/toaster.js + 2 modules
var toaster = __webpack_require__(95150);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/utils/feedback.tsx


const messageWithoutCode = (message)=>{
    return message.substring(message.indexOf(":") + 1);
};
const tryWithUserFeedback = (action)=>{
    try {
        action();
    } catch (error) {
        if (error instanceof errors/* UserInitiatedActionSemanticError */.fE) {
            toaster/* default */.Z.negative(messageWithoutCode(error.message), {
                autoHideDuration: 3000
            });
        } else {
            throw error;
        }
    }
};

;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/utils/KeyNormalizedControl.tsx





const KeyNormalizedControl = (0,es/* observer */.Pi)((props)=>{
    const [, $theme] = (0,styled/* useStyletron */.hQ)();
    const ignoreKeyProps = {
        ...props.ignoreKeyProps ?? {}
    };
    const hotKeyProps = {
        handlers: {},
        keyMap: {}
    };
    const baseExceptions = [
        "escape",
        "meta",
        "ctrl",
        "shift",
        "p",
        "k"
    ];
    if (props.mode == "form") {
        ignoreKeyProps.only = [
            "up",
            "down",
            "left",
            "right",
            "enter",
            "space",
            "Delete",
            "backspace"
        ];
    } else if (props.mode == "simple") {
        ignoreKeyProps.only = [
            "enter",
            "space"
        ];
    } else if (props.mode == "select") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.mode == "textarea") {
        ignoreKeyProps.except = baseExceptions;
    } else if (props.engagementBoundary) {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.keyMap["FINISHED_EDITING"] = [
            "enter"
        ];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hotKeyProps.handlers["FINISHED_EDITING"] = (event)=>{
            event?.preventDefault();
            tryWithUserFeedback(()=>props.onFinish?.());
        };
    } else {
        ignoreKeyProps.except = [
            ...baseExceptions,
            "up",
            "down",
            "enter"
        ];
    }
    const innerContent = /*#__PURE__*/ react.createElement(index_es.IgnoreKeys, ignoreKeyProps, props.children);
    return props.hasHotKeys ? /*#__PURE__*/ react.createElement(index_es.HotKeys, {
        ...hotKeyProps,
        style: {
            minHeight: $theme.sizing.scale1000
        }
    }, innerContent) : innerContent;
});


/***/ }),

/***/ 2780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EZ: () => (/* binding */ borderRadiiBottom),
/* harmony export */   Ik: () => (/* binding */ useFlushSyncCallback),
/* harmony export */   Lm: () => (/* binding */ multiref),
/* harmony export */   MY: () => (/* binding */ expandBorderTop),
/* harmony export */   N1: () => (/* binding */ paddingUtil),
/* harmony export */   Pb: () => (/* binding */ expandBorderLeft),
/* harmony export */   Qj: () => (/* binding */ expandBorderStyles),
/* harmony export */   SI: () => (/* binding */ marginUtil),
/* harmony export */   WB: () => (/* binding */ paddingHorizontal),
/* harmony export */   XJ: () => (/* binding */ expandBorderRight),
/* harmony export */   ds: () => (/* binding */ expandMargin),
/* harmony export */   ft: () => (/* binding */ expandPadding),
/* harmony export */   gC: () => (/* binding */ expandBorderColors),
/* harmony export */   hu: () => (/* binding */ assert),
/* harmony export */   i6: () => (/* binding */ paddingVertical),
/* harmony export */   iU: () => (/* binding */ borderRadiiTop),
/* harmony export */   ic: () => (/* binding */ borderShadow),
/* harmony export */   jT: () => (/* binding */ DISCORD_INVITE_URL),
/* harmony export */   l8: () => (/* binding */ generateTypography),
/* harmony export */   lK: () => (/* binding */ expandBorderBottom),
/* harmony export */   oM: () => (/* binding */ marginHorizontal),
/* harmony export */   pU: () => (/* binding */ marginVertical),
/* harmony export */   uJ: () => (/* binding */ expandBorderRadii),
/* harmony export */   wW: () => (/* binding */ expandBorderWidth),
/* harmony export */   yc: () => (/* binding */ expandBaseWebBorder)
/* harmony export */ });
/* unused harmony exports PrimitiveTypographyMap, borderRadiiRight, borderRadiiLeft */
/* harmony import */ var lodash_isFunction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45563);
/* harmony import */ var lodash_isFunction__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5556);



// Derived from https://github.com/gadget-inc/baseweb/blob/build-1b4286d28/themes/shared/typography.js#L155-L172
const PrimitiveTypographyMap = {
    ParagraphXSmall: "font100",
    ParagraphSmall: "font200",
    ParagraphMedium: "font300",
    ParagraphLarge: "font400",
    LabelXSmall: "font150",
    LabelSmall: "font250",
    LabelMedium: "font350",
    LabelLarge: "font450",
    HeadingXSmall: "font550",
    HeadingSmall: "font650",
    HeadingMedium: "font750",
    HeadingLarge: "font850",
    HeadingXLarge: "font950",
    HeadingXXLarge: "font1050",
    DisplayXSmall: "font1150",
    DisplaySmall: "font1250",
    DisplayMedium: "font1350",
    DisplayLarge: "font1450",
    contentLink: "contentLink"
};
const DISCORD_INVITE_URL = "https://ggt.link/discord";
/**
 * BaseUI has a bunch of redundant typography styles that can be
 * derived from a smaller set of primitives. This helper generates
 * those redundant styles.
 */ const generateTypography = (primitive)=>Object.fromEntries(Object.entries(PrimitiveTypographyMap).flatMap(([name, fontCode])=>{
        const { primaryFont: primitivePrimaryFont = {}, monoFont: primitiveMonoFont = {}, ...primitiveBaseFont } = primitive.typography ? primitive.typography[name] ?? {} : {};
        const primaryFont = {
            ...primitive.primaryFontFamily ? {
                fontFamily: primitive.primaryFontFamily
            } : {},
            ...primitiveBaseFont,
            ...primitivePrimaryFont
        };
        const monoFont = {
            ...primitive.monoFontFamily ? {
                fontFamily: primitive.monoFontFamily
            } : {},
            ...primitiveBaseFont,
            ...primitiveMonoFont
        };
        return [
            [
                fontCode,
                primaryFont
            ],
            [
                name,
                primaryFont
            ],
            [
                `Mono${name}`,
                monoFont
            ]
        ];
    }));
const nullBorder = {
    borderColor: "transparent",
    borderStyle: "solid",
    borderWidth: "0px"
};
const borderRadiiTop = (borderRadius)=>{
    return {
        borderTopLeftRadius: borderRadius,
        borderTopRightRadius: borderRadius
    };
};
const borderRadiiRight = (borderRadius)=>{
    return {
        borderTopRightRadius: borderRadius,
        borderBottomRightRadius: borderRadius
    };
};
/**
 *
 * @param border
 * @returns { borderRightWidth, borderRightStyle, borderRightColor }
 */ const expandBorderRight = (border)=>{
    if (border === "none") return expandBorderRight(nullBorder);
    return {
        borderRightWidth: border.borderWidth,
        borderRightStyle: border.borderStyle,
        borderRightColor: border.borderColor
    };
};
/**
 *
 * @param border
 * @returns { borderLeftWidth, borderLeftStyle, borderLeftColor }
 */ const expandBorderLeft = (border)=>{
    if (border === "none") return expandBorderLeft(nullBorder);
    return {
        borderLeftWidth: border.borderWidth,
        borderLeftStyle: border.borderStyle,
        borderLeftColor: border.borderColor
    };
};
/**
 *
 * @param border
 * @returns borderTopWidth, borderTopStyle, borderTopColor
 */ const expandBorderTop = (border)=>{
    if (border === "none") return expandBorderTop(nullBorder);
    return {
        borderTopWidth: border.borderWidth,
        borderTopStyle: border.borderStyle,
        borderTopColor: border.borderColor
    };
};
/**
 *
 * @param border
 * @returns { borderBottomWidth, borderBottomStyle, borderBottomColor }
 */ const expandBorderBottom = (border)=>{
    if (border === "none") return expandBorderBottom(nullBorder);
    return {
        borderBottomWidth: border.borderWidth,
        borderBottomStyle: border.borderStyle,
        borderBottomColor: border.borderColor
    };
};
const borderRadiiBottom = (borderRadius)=>{
    return {
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius
    };
};
const borderRadiiLeft = (borderRadius)=>{
    return {
        borderTopLeftRadius: borderRadius,
        borderBottomLeftRadius: borderRadius
    };
};
const expandBorderRadii = (borderRadius)=>{
    return {
        borderTopLeftRadius: borderRadius,
        borderBottomLeftRadius: borderRadius,
        borderTopRightRadius: borderRadius,
        borderBottomRightRadius: borderRadius
    };
};
const expandBorderColors = (borderColor)=>{
    return {
        borderTopColor: borderColor,
        borderRightColor: borderColor,
        borderBottomColor: borderColor,
        borderLeftColor: borderColor
    };
};
const expandBorderStyles = (borderStyle)=>{
    return {
        borderTopStyle: borderStyle,
        borderRightStyle: borderStyle,
        borderBottomStyle: borderStyle,
        borderLeftStyle: borderStyle
    };
};
const expandBorderWidth = (borderWidth)=>{
    return {
        borderTopWidth: borderWidth,
        borderRightWidth: borderWidth,
        borderBottomWidth: borderWidth,
        borderLeftWidth: borderWidth
    };
};
const expandBaseWebBorder = (border)=>{
    return {
        ...expandBorderWidth(border.borderWidth),
        ...expandBorderColors(border.borderColor),
        ...expandBorderStyles(border.borderStyle)
    };
};
/**
 *
 * @param margin
 * @returns { marginTop, marginLeft, marginRight, marginBottom }
 */ const expandMargin = (margin)=>({
        marginTop: margin,
        marginRight: margin,
        marginBottom: margin,
        marginLeft: margin
    });
/**
 *
 * @param padding
 * @returns { paddingTop, paddingLeft, paddingRight, paddingBottom }
 */ const expandPadding = (padding)=>({
        paddingTop: padding,
        paddingRight: padding,
        paddingBottom: padding,
        paddingLeft: padding
    });
/**
 * @param margin
 * @param [margin2=margin]
 * @returns { marginLeft, marginRight }
 */ const marginHorizontal = (margin, margin2 = margin)=>({
        marginLeft: margin,
        marginRight: margin2
    });
/**
 *
 * @param margin
 * @param [margin2=margin]
 * @returns { marginTop, marginBottom }
 */ const marginVertical = (margin, margin2 = margin)=>({
        marginTop: margin,
        marginBottom: margin2
    });
/**
 * @param padding
 * @param [padding2=padding]
 * @returns { paddingLeft, paddingRight }
 */ const paddingHorizontal = (padding, padding2 = padding)=>({
        paddingLeft: padding,
        paddingRight: padding2
    });
/**
 *
 * @param padding
 * @param [padding2=padding]
 * @returns { paddingTop, paddingBottom }
 */ const paddingVertical = (padding, padding2 = padding)=>({
        paddingTop: padding,
        paddingBottom: padding2
    });
/**
 * Use when you know padding sizes you want to set for all 4 sides of an element
 *
 * @param padding 1-4 size arguments (same order as CSS shorthand)
 * @returns { paddingTop, paddingLeft, paddingRight, paddingBottom }
 */ const paddingUtil = (...padding)=>{
    const [paddingArg1 = 0, paddingarg2, paddingArg3, paddingArg4] = padding;
    const paddingTop = paddingArg1;
    let paddingRight = paddingArg1, paddingBottom = paddingArg1, paddingLeft = paddingArg1;
    if (typeof paddingarg2 !== "undefined") {
        paddingRight = paddingarg2;
        paddingLeft = paddingarg2;
        if (typeof paddingArg3 !== "undefined") {
            paddingBottom = paddingArg3;
            if (typeof paddingArg4 !== "undefined") {
                paddingLeft = paddingArg4;
            }
        }
    }
    return {
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
    };
};
/**
 * Use when you know the margin sizes you want to set for all 4 sides of an element
 *
 * @param margin 1-4 size arguments (same order as CSS shorthand)
 * @returns { marginTop, marginLeft, marginRight, marginBottom }
 */ const marginUtil = (...margin)=>{
    const [marginArg1 = 0, marginarg2, marginArg3, marginArg4] = margin;
    const marginTop = marginArg1;
    let marginRight = marginArg1, marginBottom = marginArg1, marginLeft = marginArg1;
    if (typeof marginarg2 !== "undefined") {
        marginRight = marginarg2;
        marginLeft = marginarg2;
        if (typeof marginArg3 !== "undefined") {
            marginBottom = marginArg3;
            if (typeof marginArg4 !== "undefined") {
                marginLeft = marginArg4;
            }
        }
    }
    return {
        marginTop,
        marginRight,
        marginBottom,
        marginLeft
    };
};
/** CSS inset box shadows don't go on top of borders, they go next to them. But, we want to blend the box shadow with the border for the nice lighting effect on buttons. So, we use a box shadow for the border, and then apply our nice lighting box shadows on top of that one so they blend nicely. */ const borderShadow = (borderColor, borderWidth, boxShadow)=>`${boxShadow}, 0 0 0 ${borderWidth}px ${borderColor} inset`;
/** Allows the use of multiple refs with one component */ const multiref = (...refs)=>{
    return (value)=>{
        for (const ref of refs){
            if (ref) {
                if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_0___default()(ref)) {
                    ref(value);
                } else {
                    ref.current = value;
                }
            }
        }
    };
};
function assert(value, message) {
    if (!value) {
        throw new Error("assertion error" + (message ? `: ${message}` : ""));
    }
    return value;
}
// Workaround for https://github.com/facebook/react/issues/19385
// Necessary for event handlers that change focus and change react component state at the same time.
const useFlushSyncCallback = (handler, deps)=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((...args)=>{
        react_dom__WEBPACK_IMPORTED_MODULE_2__.flushSync(()=>{
            handler && handler(...args);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};


/***/ }),

/***/ 38616:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: () => (/* binding */ ClientSideDefaultFlags)
/* harmony export */ });
/* unused harmony export TestFlagDefaultState */
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _type_system_FieldType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2337);


/** Default flag state used for tests in state-trees and web */ const TestFlagDefaultState = {
    features: {
        fieldTypes: {
            [_type_system_FieldType__WEBPACK_IMPORTED_MODULE_1__/* .FieldType */ .fS.Computed]: false,
            [_type_system_FieldType__WEBPACK_IMPORTED_MODULE_1__/* .FieldType */ .fS.Color]: false,
            [_type_system_FieldType__WEBPACK_IMPORTED_MODULE_1__/* .FieldType */ .fS.Money]: false,
            [_type_system_FieldType__WEBPACK_IMPORTED_MODULE_1__/* .FieldType */ .fS.Vector]: false
        },
        preconditions: false,
        typescript: false,
        darkMode: false,
        defaultLanguageSelection: false,
        ideJSErrorChecking: false,
        editorPresence: true,
        javascriptPlaygroundLinks: false,
        actionsAsCode: false,
        fileBasedActions: false,
        aacMigration: false,
        computedViews: true,
        editorCodeGen: false,
        actionsExplainerPopup: false,
        stateInActionCode: false,
        liveQuery: false,
        codeEditorRightSideNavBar: false,
        appTemplates: false,
        codeMirrorEditor: false
    },
    internal: {
        websocketRateLimitMode: "enforce",
        canarySandbox: false,
        stagingLoki: false,
        rateLimitMode: "enforce",
        shopifyWebhookLoopDetection: false,
        upgradingFission: false,
        allowShopifyAccessTokenAPIAccess: false,
        dedicatedColumnsStrategy: false,
        apiKeysInBrowserClients: true,
        throttleExchange: false,
        liveQueryNotifications: false,
        edgeFrameworkVersion: false,
        environmentWebhookEndpoints: false,
        blackholeWebhooks: false,
        shopifyWebhookBackgroundAction: false
    },
    connections: {
        slack: false,
        twilio: false,
        sendgrid: false,
        gadget: false,
        appURL: true
    }
};
const ClientSideDefaultFlags = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, TestFlagDefaultState, {
    features: {
        editorCodeGen: false
    }
});


/***/ }),

/***/ 70490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P5: () => (/* binding */ useFlag),
/* harmony export */   Q_: () => (/* binding */ FlagsProvider),
/* harmony export */   Vb: () => (/* binding */ useFlags),
/* harmony export */   WN: () => (/* binding */ Flag),
/* harmony export */   p: () => (/* binding */ CurrentFlags)
/* harmony export */ });
/* harmony import */ var flag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18988);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77662);
/* harmony import */ var state_trees_src_GadgetFlags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38616);





const { FlagsProvider, Flag, useFlag, useFlags } = (0,flag__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
const CurrentFlags = (0,mobx__WEBPACK_IMPORTED_MODULE_3__.observable)(typeof window === "undefined" ? state_trees_src_GadgetFlags__WEBPACK_IMPORTED_MODULE_2__/* .ClientSideDefaultFlags */ ._ : window.GadgetFlags);
if (typeof window !== "undefined") {
    /** Utility for setting flag values in tests */ window.mockFlags = (newFlags)=>{
        lodash_merge__WEBPACK_IMPORTED_MODULE_1___default()(CurrentFlags, newFlags);
    };
}


/***/ }),

/***/ 30804:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ styletronDebug),
/* harmony export */   F: () => (/* binding */ styletronEngine)
/* harmony export */ });
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96492);
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7085);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81262);


const getHydrations = ()=>document.getElementsByClassName("_styletron_hydrate_");
const stylePrefix = "g-";
const styletronEngine = typeof window === "undefined" ? new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z({
    prefix: stylePrefix
}) : new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z({
    hydrate: getHydrations(),
    prefix: stylePrefix
});
const shouldNotDebug =  true || 0;
const styletronDebug = shouldNotDebug ? undefined : new styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .DebugEngine */ .WA();


/***/ })

}]);